// extracted by mini-css-extract-plugin
export var buttonBar = "_redotech-redo-return-app-src-order-orders-button-bar";
export var disabled = "_redotech-redo-return-app-src-order-orders-disabled";
export var dropdown = "_redotech-redo-return-app-src-order-orders-dropdown";
export var idText = "_redotech-redo-return-app-src-order-orders-id-text";
export var link = "_redotech-redo-return-app-src-order-orders-link";
export var mobileFlex = "_redotech-redo-return-app-src-order-orders-mobile-flex";
export var ordersCard = "_redotech-redo-return-app-src-order-orders-orders-card";
export var ordersPage = "_redotech-redo-return-app-src-order-orders-orders-page";
export var subheader = "_redotech-redo-return-app-src-order-orders-subheader";
export var table = "_redotech-redo-return-app-src-order-orders-table";
export var tableData = "_redotech-redo-return-app-src-order-orders-table-data";
export var tableHeader = "_redotech-redo-return-app-src-order-orders-table-header";
export var tableHeaderText = "_redotech-redo-return-app-src-order-orders-table-header-text";
export var tableRow = "_redotech-redo-return-app-src-order-orders-table-row";
export var tableText = "_redotech-redo-return-app-src-order-orders-table-text";
export var title = "_redotech-redo-return-app-src-order-orders-title";
export var verticalButtonBar = "_redotech-redo-return-app-src-order-orders-vertical-button-bar";